var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mobileView)?_c('button',{staticClass:"table-btn focus:outline-none block",on:{"click":_vm.toggleSidebar}},[_c('icon',{staticClass:"fill-primary",attrs:{"icon":_vm.FiltersSvg}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }